import { render } from "./CounterpartyChangeDialog.vue?vue&type=template&id=7d8d3f50&ts=true"
import script from "./CounterpartyChangeDialog.vue?vue&type=script&lang=ts"
export * from "./CounterpartyChangeDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn});
